// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__AUIS8","dragIcon":"Choice_dragIcon__3LagC","left":"Choice_left__1fm9z","input":"Choice_input__2OywS"};